// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Kbmn","signatureBlock":"Footer_signatureBlock__1Vacc","signature":"Footer_signature__QjpQ9"};